module.exports = __webpack_public_path__ + "img/padlock-unlocked-green.35afe401.svg";